const sitemapButtons = document.querySelectorAll(".sitemap-link-btn")

sitemapButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const containers = button.parentNode.getElementsByClassName("content")

    if (containers[0].classList.contains("hidden")) {
      containers[0].classList.remove("hidden")
    } else {
      containers[0].classList.add("hidden")
    }
  })
})
